// blog data

export const Blogs = [
  {
    id: 1,
    name: "LODBOD (Web App)",
    tags: [],
    date: "LODBOD is a transportation management system designed to streamline process of connecting shippers with vehicle owners.",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1746439868/Screenshot_from_2025-05-05_15-55-33_zumukh.png",
    link: "https://live.lodbod.com/",
  },
  {
    id: 100,
    name: "LODBOD (Mobile App)",
    tags: [],
    date: "LODBOD is a transportation management system designed to streamline process of connecting shippers with vehicle owners.",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/v1774280485/unnamed_4_gsxi2j.jpg",
    link: "https://play.google.com/store/apps/details?id=com.bitspanda.lodbod&hl=en",
  },
  {
    id: 2,
    name: "Hiboo",
    tags: [],
    date: "Hiboo is a software that collects data from all your heavy equipment and utility vehicles in one place — enhancing your productivity and energy efficiency seamlessly.",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069208/Screenshot_from_2024-06-23_15-18-23_amworq.png",
    link: "https://www.hiboo.io/",
  },
  {
    id: 3,
    name: "Playbook",
    tags: [],
    date: "Playbook is the most comprehensive and affordable virtual jazz music program on the market, and makes learning jazz an accessible opportunity for students",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069210/Screenshot_from_2024-06-23_15-16-59_tckabt.png",
    link: "https://www.thisisplaybook.com/",
  },
  {
    id: 4,
    name: "Ariel Finance",
    tags: [],
    date: "Ariel Finance offers seamless trading of cypto assets with leverage upto 25x",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069211/Screenshot_from_2024-06-23_15-38-41_ib7c65.png",
    link: "https://www.arielfinance.io/",
  },
  {
    id: 5,
    name: "MovePad",
    tags: [],
    date: "MovePad offers platform and services to lunch your ICO",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069215/Screenshot_from_2024-06-23_15-33-27_efrzsz.png",
    link: "https://www.movepad.io/",
  },
  {
    id: 6,
    name: "Yolo",
    tags: [],
    date: "Yoloswap provides user the ability swap cypto assets instantly at fraction of fee",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069212/Screenshot_from_2024-06-23_16-15-47_bzqgjn.png",
    link: "https://yoloswap.com/",
  },
  {
    id: 7,
    name: "Mondou",
    tags: [],
    date: "Shop all the needs for your pet at one stop",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069216/Screenshot_from_2024-06-23_17-06-26_kjrmdh.png",
    link: "https://www.mondou.com/",
  },
  {
    id: 8,
    name: "Suiheroes",
    tags: [],
    date: "Online casino games with crypto assets",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069215/Screenshot_from_2024-06-23_16-28-42_kiiofp.png",
    link: "https://suiheroes.com/",
  },
  {
    id: 9,
    name: "Lumanagi",
    tags: [],
    date: "A digital asset exchange hub with continuously increasing gold-backing",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/t_portfolio%20site/v1720069215/Screenshot_from_2024-06-23_16-39-57_yhythe.png",
    link: "https://lumanagi.com/",
  },
  {
    id: 11,
    name: "Hirenest",
    tags: [],
    date: "Hirenest is a platform that connects employers with top-tier talent, streamlining the hiring process",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/v1774269741/Screenshot_from_2026-03-23_18-25-36_w4v6bu.png",
    link: "https://www.hirenest.uk/",
  },
   {
    id: 12,
    name: "Zielony Zakątek",
    tags: [],
    date: "Zielony Zakątek is a supermarket in poland that offers a wide range of fresh and organic produce",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/v1774280969/Screenshot_from_2026-03-23_21-34-00_dmoyep.png",
    link: "https://www.zielonyzakatek.space/",
  },
{
    id: 13,
    name: "Edelgrün",
    tags: [],
    date: "Edelgrün is a supermarket in poland that offers a wide range of  farm products",
    imgSrc:
      "https://res.cloudinary.com/dmphgxgck/image/upload/v1774281191/Screenshot_from_2026-03-23_21-37-50_dyr0vy.png",
    link: "https://www.edelgruen.store/",
  },
];
